import { AppRouteProps } from "@harea/component";
import React from "react";
import LateCreateContainer from "./container/LateCreateContainer";
import LateDetailsContainer from "../details/container/LateDetailsContainer";

const LateFormContainer = React.lazy(
  () => import("./container/LateFormContainer")
);

export const LateCreateRoutes: Array<AppRouteProps> = [
  {
    path: "create",
    element: <LateCreateContainer />,
    children: [
      {
        path: "",
        element: <LateFormContainer />,
      },
    ],
  },
];

export const LateDetailsRoute: AppRouteProps = {
  path: ":id",
  element: <LateDetailsContainer />,
};
